export default __webpack_public_path__ + "mytributes/images/favicon-32x32.png";